import defaultSettings from "@/settings";

const title = defaultSettings.title || "Arcanite";

export function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}
